<template>
	<div class="user-panel">
		<header>Oświadczenie o rezydencji podatkowej</header>

		<div class="user-panel-form">
			<div class="statement">
				W związku z regulacjami:
				<ul>
					<li>
						Ustawą z dnia 9 października 2015r. o wykonywaniu Umowy
						między Rządem Rzeczypospolitej Polskiej, a Rządem Stanów
						Zjednoczonych Ameryki w sprawie poprawy wypełniania
						międzynarodowych obowiązków podatkowych oraz wdrożenia
						ustawodawstwa FATCA (zwana dalej: "Ustawa FATCA"), oraz
					</li>
					<li>
						Ustawą z dnia 9 marca 2017r. o wymianie informacji
						podatkowych z innymi państwami (zwana dalej "Ustawa
						CRS"),
					</li>
				</ul>
				niniejszym składam oświadczenie
				<br /><br />
			</div>
			<p>
				Jestem świadomy odpowiedzialności karnej za złożenie fałszywego
				oświadczenia.
			</p>

			<div class="d-none">
				<v-checkbox
					:htmlId="'IsResident'"
					:checked="myFx.isResident"
					:readonly="true"
					:label="'rozliczam się z podatków w Polsce (jestem Polskim rezydentem podatkowym)'"
				/>
			</div>
			<p v-if="myFx.isResident">
				Oświadczam, że rozliczam się z podatków w Polsce (jestem Polskim
				rezydentem podatkowym)
			</p>
			<p v-else>
				Oświadczam, że nie rozliczam się z podatków w Polsce (nie jestem
				Polskim rezydentem podatkowym), ponieważ wskazałem adres
				zamieszkania poza Polską.
			</p>
			<template v-if="!myFx.isResident">
				<v-input
					:label="'Imię matki'"
					:htmlId="'MotherName'"
					:value="myFx.motherName"
				/>
				<v-input
					:label="'Imię ojca'"
					:htmlId="'FatherName'"
					:value="myFx.fatherName"
				/>
			</template>
		</div>

		<div class="user-panel-form clearfix" style="margin-bottom: 15px">
			<div class="form-col">
				<v-select
					:label="'Urząd Skarbowy'"
					:htmlId="'TaxCityId'"
					:list="taxCities"
					:searchable="true"
					:disable="disabledTaxCity"
					@change="reloadTaxOffices($event)"
					:value="myFx.taxCityId ? myFx.taxCityId.toString() : ''"
				/>
			</div>
			<div class="form-col">
				<v-select
					:label="'Adres właściwego Urzędu Skarbowego'"
					:htmlId="'TaxOfficeId'"
					:list="taxOffices"
					:searchable="true"
					:disable="disabledTaxOffice"
					@change="selectTaxOffice($event)"
					:value="myFx.taxOfficeId ? myFx.taxOfficeId.toString() : ''"
				/>
			</div>
		</div>
		<template v-if="!myFx.isResident">
			<p style="margin-bottom: 30px">
				W związku ze zmianą adresu zamieszkania z polskiego na
				zagraniczny, właściwy urząd skarbowy do rozliczeń podatkowych w
				ramach usługi mForex został oznaczony jako III Urząd Skarbowy w
				Warszawie z siedzibą przy ul. Lindleya 14
			</p>
		</template>

		<div class="user-panel-form">
			<v-checkbox
				:htmlId="'isUsaTaxPayeeOrHasUsaCitizenship'"
				:label="'jestem obywatelem USA/jestem amerykańskim rezydentem podatkowym zgodnie z amerykańskim kodeksem podatkowym**'"
				:checked="myFx.isUsaTaxPayeeOrHasUsaCitizenship"
			/>
		</div>

		<div
			class="user-panel-form clearfix"
			v-if="myFx.isUsaTaxPayeeOrHasUsaCitizenship"
			style="margin-bottom: 30px"
		>
			<div class="tin-input">
				<v-input
					:label="'Numer TIN'"
					:htmlId="'UsaTin'"
					:maxlength="9"
					:value="myFx.usaTin"
				/>
			</div>
			<div
				class="img-question"
				style="padding-top: 5px; position: relative"
			>
				<img
					src="images/question.png"
					@mouseover="toggleUsaTaxPayeeTooltip(true)"
					@mouseout="toggleUsaTaxPayeeTooltip(false)"
					class="question-icon qi-tin"
				/>

				<transition tag="div" name="fade">
					<div
						class="tooltip tin-tooltip"
						style="margin-top: -45px; left: 40px"
						v-show="showUsaTaxPayeeTooltip"
					>
						Numer identyfikacji podatkowej w USA (Tax Identification
						Number) dotyczy tylko podatników USA
					</div>
				</transition>
			</div>
		</div>

		<div
			style="
				display: inline-block;
				margin-right: 15px;
				margin-bottom: 15px;
			"
		>
			<v-checkbox
				:htmlId="'isOtherCountryTaxPayee'"
				:label="'jestem podatnikiem (rezydentem podatkowym) w innych państwach'"
				:checked="myFx.isOtherCountryTaxPayee"
			/>
		</div>

		<button
			v-if="myFx.isOtherCountryTaxPayee"
			type="button"
			class="btn btn-secondary mb-3"
			:disabled="myFx.countryOfTaxPayee.length >= 3"
			@click="addOtherCountryTaxRow()"
		>
			Dodaj ({{ myFx.countryOfTaxPayee.length }}/3)
		</button>

		<div
			v-for="(item, i) in myFx.countryOfTaxPayee"
			:key="'CountryOfTaxPayee_' + i"
		>
			<panel-resident-statement-of-tax-payee
				:countries="otherTaxCountries"
				:item="item"
				:index="i"
			/>
		</div>
	</div>
</template>

<script>
import { getDictionaryItem } from '@/mixins/get-dictionary-item';
import { getMyFx } from '@/mixins/get-my-fx';
import PanelResidentStatementOfTaxPayee from '@/views/myFx/partial/_PanelResidentStatementOfTaxPayee';

export default {
	data() {
		return {
			taxOffices: [],
			openTaxOffices: false,
			showUsaTaxPayeeTooltip: false,
		};
	},
	components: {
		PanelResidentStatementOfTaxPayee,
	},
	mixins: [getDictionaryItem, getMyFx],
	props: {
		taxCities: {
			type: Array,
			required: true,
		},
		taxAddresses: {
			type: Array,
			required: true,
		},
		otherTaxCountries: {
			type: Array,
			required: true,
		},
	},
	methods: {
		reloadTaxOffices(e) {
			this.$store.commit('setTaxOfficeId', null);
			this.filterAddresses(e);
			this.taxOfficeLabel();
		},
		filterAddresses(e) {
			this.taxOffices = this.taxAddresses.filter((item) => {
				return item.parentId === e;
			});
		},
		selectTaxOffice(e) {
			this.$store.commit('setTaxOfficeId', e);
			this.openTaxOffices = false;
		},
		addOtherCountryTaxRow() {
			this.$store.commit('addOtherCountryTaxRow');
		},
		closeTaxOffice() {
			this.openTaxOffices = false;
		},
		taxOfficeLabel() {
			return this.getDictionaryItem(
				this.taxAddresses,
				'text',
				'value',
				parseInt(this.myFx.taxOfficeId)
			);
		},
		toggleUsaTaxPayeeTooltip(show) {
			this.showUsaTaxPayeeTooltip = show;
		},
	},
	mounted() {
		this.filterAddresses(this.myFx.taxCityId);
	},
	computed: {
		classSelectListTaxOffices() {
			return this.myFx.mainAddress.countryId == 160
				? 'select'
				: 'select disabled';
		},
		disabledTaxCity() {
			return (
				this.myFx.taxCityId === 705 &&
				this.myFx.mainAddress.countryId !== 160
			);
		},
		disabledTaxOffice() {
			return (
				this.myFx.taxCityId == '' ||
				this.myFx.taxCityId == null ||
				this.myFx.mainAddress.countryId !== 160
			);
		},
	},
};
</script>
